import React from "react";
import DispatchRulesDataProvider from "../providers/DispatchRulesDataProvider";
import {JobTypes} from "../components/settings/ColorSettings/ColorizedIndicators/types/jobTypeSelectorValues";
import AssignedStopsView from "./AssignedStopsView";
import ListActionBarProvider from "../components/common/ListActionBarProvider";

const AssignedStopsViewContainer = () => {
  return (
    <ListActionBarProvider>
      <DispatchRulesDataProvider jobType={JobTypes.AssignedStops}>
        <AssignedStopsView />
      </DispatchRulesDataProvider>
    </ListActionBarProvider>
  );
};

export default AssignedStopsViewContainer;
